import * as React from "react";
const SvgFiRrOctagonMinus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-octagon-minus_svg__a)">
      <path
        fill="#062147"
        d="m22.243 5.272-3.515-3.515A5.97 5.97 0 0 0 14.485 0H9.514a5.97 5.97 0 0 0-4.243 1.757L1.756 5.272A5.97 5.97 0 0 0-.001 9.515v4.971c0 1.602.624 3.109 1.757 4.243l3.515 3.515a5.97 5.97 0 0 0 4.243 1.757h4.971a5.97 5.97 0 0 0 4.243-1.757l3.515-3.515A5.97 5.97 0 0 0 24 14.486V9.515a5.97 5.97 0 0 0-1.757-4.243M22 14.485a3.98 3.98 0 0 1-1.171 2.829l-3.515 3.514A3.97 3.97 0 0 1 14.485 22H9.514a3.98 3.98 0 0 1-2.829-1.171l-3.514-3.515a3.97 3.97 0 0 1-1.172-2.829V9.514c0-1.068.416-2.073 1.171-2.829l3.515-3.514a3.97 3.97 0 0 1 2.829-1.172h4.971c1.068 0 2.073.416 2.829 1.171l3.514 3.515A3.97 3.97 0 0 1 22 9.514zM18 12a1 1 0 0 1-1 1H7a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-octagon-minus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOctagonMinus;
